// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoogleCircleFilledSvg from "@ant-design/icons-svg/es/asn/GoogleCircleFilled";
import AntdIcon from '../components/AntdIcon';

var GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoogleCircleFilledSvg
  }));
};

GoogleCircleFilled.displayName = 'GoogleCircleFilled';
export default React.forwardRef(GoogleCircleFilled);